import styled from "styled-components";
import React, { useState } from "react";
import { useTranslate } from "@tolgee/react";
import { ReactComponent as ArrowBackIcon } from "../../../Assets/icons/arrowBack.svg";

export const Hero = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
  margin-bottom: 8px;
`;

export const Globe = styled.div`
  font-size: 48px;
  line-height: 1;
  margin-bottom: 4px;
`;

export const Title = styled.h2`
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  letter-spacing: -0.5px;
  white-space: nowrap;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  line-height: 1.65;
`;

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Hint = styled.p`
  font-size: 13px;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  text-align: center;
  opacity: 0.7;
`;

export const InputRow = styled.div`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.menu.enterPhoneNumberBackground};
  border-radius: 14px;
  padding: 4px 4px 4px 18px;
  border: 1px solid
    ${({ focused, theme }) =>
      focused ? theme.menu.selectedTextColor : theme.sidebar.borderColor};
  transition: border-color 0.2s, box-shadow 0.2s;
  box-shadow: ${({ focused, theme }) =>
    focused ? `0 0 0 3px ${theme.menu.selectedTextColor}22` : "none"};
`;

export const TextInput = styled.input`
  flex: 1;
  background: none;
  border: none;
  outline: none;
  font-size: 15px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  padding: 14px 0;
  font-family: inherit;

  &::placeholder {
    color: ${({ theme }) => theme.menu.secondaryTextColor};
    opacity: 0.7;
  }
`;

export const PrimaryBtn = styled.button`
  width: 100%;
  padding: 16px;
  border-radius: 14px;
  border: none;
  background: ${({ theme }) => theme.menu.selectedTextColor};
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  letter-spacing: 0.2px;
  transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 8px 24px ${({ theme }) => theme.menu.selectedTextColor}55;
  }

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
`;

const BackBtnStyled = styled.button`
  align-self: flex-start;
  background: none;
  border: none;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  font-family: inherit;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  opacity: 0.7;
  transition: opacity 0.15s;

  &:hover {
    opacity: 1;
  }

  svg {
    flex-shrink: 0;
  }
`;

export const BackBtn = ({ onClick, children }) => (
  <BackBtnStyled onClick={onClick}>
    <ArrowBackIcon />
    {children}
  </BackBtnStyled>
);

export const Divider = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 12px;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  opacity: 0.6;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: ${({ theme }) => theme.sidebar.borderColor};
  }
`;

export const Terms = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  text-align: center;
  line-height: 1.5;
  opacity: 0.6;
  margin-top: 4px;
`;

export const TermsLink = styled.span`
  color: ${({ theme }) => theme.menu.selectedTextColor};
  cursor: pointer;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;

export const EmailBadge = styled.div`
  align-self: center;
  padding: 7px 16px;
  border-radius: 100px;
  background: ${({ theme }) => theme.menu.enterPhoneNumberBackground};
  border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  font-size: 13px;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  font-weight: 500;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ErrorText = styled.p`
  font-size: 13px;
  color: ${({ theme }) => theme.menu.deleteColor};
  text-align: left;
  font-weight: 500;
`;

export const TextLink = styled.button`
  background: none;
  border: none;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.menu.selectedTextColor};
  cursor: pointer;
  padding: 0;
  text-align: center;
  opacity: 0.85;
  transition: opacity 0.15s;

  &:hover {
    opacity: 1;
    text-decoration: underline;
  }
`;

const PasswordRowWrapper = styled.div`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.menu.enterPhoneNumberBackground};
  border-radius: 14px;
  padding: 4px 4px 4px 18px;
  border: 1px solid
    ${({ focused, theme }) =>
      focused ? theme.menu.selectedTextColor : theme.sidebar.borderColor};
  transition: border-color 0.2s, box-shadow 0.2s;
  box-shadow: ${({ focused, theme }) =>
    focused ? `0 0 0 3px ${theme.menu.selectedTextColor}22` : "none"};
`;

const PasswordRawInput = styled.input`
  flex: 1;
  background: none;
  border: none;
  outline: none;
  font-size: 15px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  padding: 14px 0;
  font-family: inherit;

  &::placeholder {
    color: ${({ theme }) => theme.menu.secondaryTextColor};
    opacity: 0.7;
  }
`;

const ShowHideBtn = styled.button`
  background: none;
  border: none;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.menu.selectedTextColor};
  cursor: pointer;
  padding: 8px 12px;
  opacity: 0.7;
  transition: opacity 0.15s;
  flex-shrink: 0;

  &:hover {
    opacity: 1;
  }
`;

export const OtpWrapper = styled.div`
  width: 100%;
`;

export const OtpBox = styled.input`
  flex: 1;
  min-width: 0;
  padding: 14px 8px;
  border-radius: 12px;
  border: 1px solid ${({ error, theme }) => error ? theme.menu.deleteColor : theme.sidebar.borderColor};
  color: ${({ theme }) => theme.menu.primaryTextColor};
  background: ${({ theme }) => theme.menu.enterPhoneNumberBackground};
  font-size: 22px;
  font-weight: 700;
  text-align: center;
  font-family: inherit;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus {
    border-color: ${({ theme }) => theme.menu.selectedTextColor};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.menu.selectedTextColor}22;
  }
`;

export const ResendSuccess = styled.p`
  font-size: 13px;
  color: #23c55e;
  text-align: left;
  font-weight: 500;
`;

export const ResendTimer = styled.p`
  font-size: 13px;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  text-align: center;
  opacity: 0.6;
`;

export const TermsFooter = () => {
  const { t } = useTranslate();
  return (
    <Terms>
      {t("authentication.terms_prefix")}{" "}
      <TermsLink onClick={() => window.open("https://www.emotii.ai/terms", "_blank")}>
        {t("general.terms_and_conditions")}
      </TermsLink>
    </Terms>
  );
};

export const PasswordInput = ({ placeholder, autoComplete, onKeyDown, ...props }) => {
  const { t } = useTranslate();
  const [show, setShow] = useState(false);
  const [focused, setFocused] = useState(false);
  return (
    <PasswordRowWrapper focused={focused}>
      <PasswordRawInput
        type={show ? "text" : "password"}
        placeholder={placeholder}
        autoComplete={autoComplete || "current-password"}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        onKeyDown={onKeyDown}
        {...props}
      />
      <ShowHideBtn type="button" onClick={() => setShow((s) => !s)}>
        {show ? t("general.hide") : t("authentication.password.show")}
      </ShowHideBtn>
    </PasswordRowWrapper>
  );
};
